import { render, staticRenderFns } from "./VueSkipTo.vue?vue&type=template&id=6de35538"
import script from "./VueSkipTo.vue?vue&type=script&lang=ts"
export * from "./VueSkipTo.vue?vue&type=script&lang=ts"
import style0 from "./VueSkipTo.vue?vue&type=style&index=0&id=6de35538&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports